import { render } from "./DisegnoSerramentoSvg.vue?vue&type=template&id=7158d790&scoped=true"
import script from "./DisegnoSerramentoSvg.vue?vue&type=script&lang=js"
export * from "./DisegnoSerramentoSvg.vue?vue&type=script&lang=js"

import "./DisegnoSerramentoSvg.vue?vue&type=style&index=0&id=7158d790&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7158d790"]])

export default __exports__